import { createApp } from 'vue'
import App from './App.vue'
import router from '@/router';
import vueCookies from 'vue-cookies';
import Antd from 'ant-design-vue';
// import 'ant-design-vue/dist/reset.css';
import './assets/fonts/iconfont.css'; // 引入图标字体
import './style/romove-default.css'; // 引入去除默认样式
import './style/public.css'; // 引入公共样式
import './style/navigation/index.css'; // 引入导航栏样式
import './style/footer/index.css'; // 引入页尾样式
import './style/site-map/index.css'; // 引入网站地图样式


import uImage from '@/components/uImage.vue';

const app = createApp( App );
app.use(router);
app.use(vueCookies);
app.use(Antd);
app.component('uImage',uImage)
app.mount('#app');
